<template>
    <custom-select
            valueField="slug"
            labelField="label"
            v-model="selectedShipTypeValue"
            :options="option"
            v-on:change="updateFilter($event)"
    ></custom-select>
</template>

<script>
    import IsotopeStuff from '../../libs/IsotopeStuff';

    export default {
        props: {},
        data() {
            return {
                selectedShipTypeValue: '*',
                option: [
                    {
                        label: 'Tous les navires',
                        slug: '*'
                    },
                    {
                        label: 'Brise-Glaces',
                        slug: '.briseGlace'
                    },
                    {
                        label: 'Navires polaires',
                        slug: '.bateauPolaire'
                    },
                    {
                        label: 'Yachts Polaires',
                        slug: '.yachtPolaire'
                    },
                    {
                        label: 'Yachts',
                        slug: '.yacht'
                    },
                ]
            };
        },
        methods: {
            updateFilter(filterValue) {
                location.hash = 'filter=' + encodeURIComponent(filterValue);
            }

        },
        mounted() {

            setTimeout(() => {
                this.selectedShipTypeValue = IsotopeStuff.getHashFilter();
            }, 500);


            $('.filtres li').on('click', (event) => {
                var filterValue = $(event.currentTarget).attr('data-filter');
                this.selectedShipTypeValue = filterValue;
            });

        },
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/ship/ShipFilter.vue